export default "__VITE_ASSET__CMmM$nfz__"